//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryPayInfo } from '@/https/prepareEnroll'
import TCardItem from '@/TShareComponent/TCardItem'

export default {
  components: { TCardItem },

  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return {
      payList: [],
      loading: false,
      msg: '暂无需缴费的费用',
    }
  },

  computed: {},

  created () {
    this.setPayInfo()
  },

  methods: {
    async setPayInfo () {
      this.loading = true
      const { data } = await queryPayInfo()
      this.payList = data || []
      this.loading = false
    },

    goPayDetail (enroll) {
      this.$router.push({
        path: '/preparePayDetail',
        query: { pcdm: enroll.pcdm },
      })
    },

    handlerEnroll (enroll) {
      this.$router.push({
        path: '/preparePayNotice',
        query: {
          pcdm: enroll.pcdm,
          jzsj: enroll.jzsj,
        },
      })
    },
  },
}
